import React from 'react';
import { Link } from 'react-router-dom';
import { GlobeAltIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../contexts/LanguageContext';
import aaaPdf from '../../assets/aaa.pdf';
import './FooterBottom.css';

const FooterBottom: React.FC = () => {
  const { t } = useTranslation();
  const { currentLanguage, languages } = useLanguage();
  const currentYear = new Date().getFullYear();
  
  const currentLang = languages.find(lang => lang.code === currentLanguage);

  const legalLinks = [
    { nameKey: 'footer.privacyPolicy', path: aaaPdf, openPdf: true },
    { nameKey: 'footer.termsOfService', path: aaaPdf, openPdf: true },
    { nameKey: 'footer.cookiePolicy', path: '/cookies' },
    { nameKey: 'footer.accessibility', path: '/accessibility' }
  ];

  return (
    <div className="footer-bottom">
      <div className="footer-bottom-content">
        <div className="footer-bottom-left">
          <p className="copyright">
            &copy; {currentYear} Protix. {t('footer.copyright')}
          </p>
        </div>
        <div className="footer-bottom-right">
          <div className="footer-bottom-links">
            {legalLinks.map((link, index) =>
              link.openPdf ? (
                <a
                  key={link.nameKey}
                  href={link.path}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="legal-link"
                >
                  {t(link.nameKey)}
                </a>
              ) : (
                <Link key={link.nameKey} to={link.path} className="legal-link">
                  {t(link.nameKey)}
                </Link>
              )
            )}
          </div>
          <div className="footer-languages">
            <GlobeAltIcon className="globe-icon" />
            <span className="language-text">{currentLang?.nativeName || t(`language.${currentLanguage}`)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterBottom;
